export default {
  eqp_month_border: 6,
  eqp_day_border: 180,
  hued_month_border: 15,
  hued_day_border: 450
}
